module.exports = __webpack_public_path__ + "img/wordpress.c0553214.png";